import template from './diversificationReferralEdit.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
controller: class controller {
    constructor($mdDialog, $mdMedia, eventService) {
      'ngInject';
      /*
       * Controller model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.destroyWatch = eventService.onDialogDiversificationReferralEdit((params) => {
          $mdDialog
            .show({
              targetEvent: params.event,
              locals: {
                icon: params.icon || 'radio_button_checked',
                title: params.title,
                fieldReferralTitle: params.fieldReferralTitle || 'Email',
                fieldTemplateTitle: params.fieldTemplateTitle || 'Select',
                options: params.options,
                selected: params.selected,
                referral: params.referral
              },
              template,
              controllerAs: '$ctrl',
              controller(
                icon,
                title,
                fieldReferralTitle,
                fieldTemplateTitle,
                options,
                selected,
                referral
              ) {
                const ctr = this;
                ctr.icon = icon;
                ctr.title = title;
                ctr.fieldReferralTitle = fieldReferralTitle;
                ctr.fieldTemplateTitle = fieldTemplateTitle;
                ctr.options = options;
                ctr.selected = selected;
                ctr.referral = referral;
                ctr.confirm = () => {
                  if (ctr.selected && ctr.referral) {
                    $mdDialog.hide({ selected: ctr.selected, referral: ctr.referral });
                  }
                };
                ctr.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then((res) => {
              if (ctrl.onFinished) {
                ctrl.onFinished({
                  result: { id: params.id, selected: res.selected, referral: res.referral }
                });
              }
            });
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
